
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component
export default class VirtualPOIModal extends Vue {
  visible = false;

  formDate: any = {
    shopName: '',
    virtualPoi: '',
  };

  @lazyInject(ShopService)
  shopService!: ShopService;

  init(val: any) {
    const { shop_name, virtual_poi } = val;
    this.formDate.shopName = shop_name;
    this.formDate.virtualPoi = virtual_poi;
    this.visible = true;
  }
  onClose() {
    this.visible = false;
  }
  async onSubmit() {
    const res = await this.shopService.postPointEditShopName(this.formDate);
    if (res) {
      this.$message.success('修改成功');
      this.$emit('search');
      this.visible = false;
    }
  }
}

